const pluralize = (length: number, single: string, plural?: string): string => {
  if (plural == null) {
    plural = single + "s"
  }
  return length === 1 ? single : plural
}

export { pluralize }
